import { AnalyticsEventTracker } from "src/app/nutrigenic/models/analytics-event-tracker.model";

export class ViewItemListEventTracker implements AnalyticsEventTracker {
  constructor(private eventName: string) {
    this.eventName = eventName;
  }

  getProcessedData(rawEventData: any) {
    if (!rawEventData.ecommerce.items.length) return;

    const event = {
      ecommerce: {
        /*item_list_name: 'Meal Plans',
        items: [
          {
            item_id: rawEventData.id,
            item_name: rawEventData.title
          },
        ],*/
      },
    };
    
    return {
      //item_list_name: 'Meal Plans',
      eventData: event,
    };
  }
}
